import ThankYouPage from "@/components/ThankYouPage";

const MerciAccompagnement = () => (
  <ThankYouPage
    eventName="Lead"
    contentName="Accompagnement · Formulaire"
    title="C'est reçu."
    body={`Votre demande est entre nos mains.

On revient vers vous par téléphone très bientôt pour discuter de votre entreprise et de vos objectifs.`}
    backTo="/accompagnement"
    backLabel="Retour à l'accompagnement"
    canonical="/merci/accompagnement"
  />
);

export default MerciAccompagnement;
